import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { Tablist } from "@/components/Interface/Tablist/Tablist";
import { PortalHeading } from "@/components/Portal/PortalHeading/PortalHeading";

export const Documents: FC = () => {
  const { t } = useTranslation("portal");

  return (
    <>
      <div id="documents-controls-portal" />
      <PortalHeading heading={t("documents.heading")}>
        <p className="mb-14 mt-8 md:mt-10">{t("documents.subheading")}</p>
      </PortalHeading>
      <div className="relative min-h-[560px] overflow-hidden bg-white md:px-10 md:pb-20 md:pt-10 md:shadow-[0_0_14px_2px_rgba(0,20,255,0.2)]">
        <Tablist
          tabs={[
            {
              target: "bills",
              disabled: false,
              showHint: false,
              text: t("bills.heading"),
            },
            {
              target: "payments",
              disabled: false,
              showHint: false,
              text: t("user-account.tabs.paymentMethods"),
            },
          ]}
        />
        <Outlet />
      </div>
    </>
  );
};
